import { ComponentInstance } from '@uniformdev/canvas';

import {
	Breadcrumbs,
	type BreadcrumbsProps,
} from '@/libraries/design/components/breadcrumbs/src/breadcrumbs';

export interface UniformBreadcrumbsProps {
	component: ComponentInstance;
}

const UniformBreadcrumbs = ({ component }: UniformBreadcrumbsProps) => {
	const slotItems = component.slots?.['links'] ?? [];
	if (slotItems.length === 0) return null;

	const links: BreadcrumbsProps['links'] = slotItems
		.filter((child) => child.type === 'breadcrumbLink')
		.map((child) => ({
			name: (child.parameters?.['name']?.value as string) ?? '',
			path: (child.parameters?.['path']?.value as string) ?? '',
		}))
		.filter((link) => link.name && link.path);

	if (links.length === 0) return null;

	return (
		<Breadcrumbs
			links={links}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'linkButton',
				'data-event-container': 'breadcrumbs',
				'data-event': 'clicked',
			}}
		/>
	);
};

export default UniformBreadcrumbs;
